!function() {
  var t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : {}, e = {}, i = {}, r = t.parcelRequire5f74;
  null == r && ((r = function(t) {
    if (t in e) return e[t].exports;
    if (t in i) {
      var r = i[t];
      delete i[t];
      var a = {
        id: t,
        exports: {}
      };
      return e[t] = a, r.call(a.exports, a, a.exports), a.exports;
    }
    var s = new Error("Cannot find module '" + t + "'");
    throw s.code = "MODULE_NOT_FOUND", s;
  }).register = function(t, e) {
    i[t] = e;
  }, t.parcelRequire5f74 = r), (0, r.register)("kmbQD", (function(t, e) {
    var i, r, a, s;
    i = t.exports, r = "default", a = function() {
      return o;
    }, Object.defineProperty(i, r, {
      get: a,
      set: s,
      enumerable: !0,
      configurable: !0
    });
    class o {
      static doChange({id: t, quantity: e, properties: i = {}}, r = !1) {
        return fetch(`${window.Shopify?.routes?.root || "/"}cart/change.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            id: t,
            quantity: e,
            properties: {
              ...i
            }
          })
        }).then((t => {
          if (!t.ok) throw new Error("Cart change failed");
          return t.ok && r && this.update(!0), t;
        })).catch((t => t));
      }
      static doUpdate(t, e, i = !1) {
        const r = Array.isArray(t) ? t.reduce(((t, i) => ({
          ...t,
          [i]: e
        })), {}) : {
          id: e
        };
        return fetch(`${window.Shopify?.routes?.root || "/"}cart/update.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            updates: r
          })
        }).then((t => {
          if (!t.ok) throw new Error("Cart update failed");
          return t.ok && i && this.update(!0), t;
        })).catch((t => t));
      }
      static doAdd({id: t, quantity: e, properties: i = {}}, r = !1) {
        return fetch(`${window.Shopify?.routes?.root || "/"}cart/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            items: [ {
              id: t,
              quantity: e,
              properties: {
                ...i
              }
            } ]
          })
        }).then((t => {
          if (!t.ok) throw new Error("Cart add failed");
          return t.ok && r && this.update(!0), t;
        })).catch((t => t));
      }
      static getCart() {
        return fetch(`${window.Shopify?.routes?.root || "/"}cart.js`, {
          method: "GET",
          headers: {
            Accept: "application/json"
          }
        }).then((t => {
          if (!t.ok) throw new Error("Failed to fetch cart");
          return t;
        })).catch((t => t));
      }
      static update(t = !1, e = "cart-drawer", i = null) {
        try {
          e = e.replace("cart-drawer", document.querySelector("cart-drawer").closest(".shopify-section").getAttribute("id").match(/shopify-section-(.*)$/)[1]);
        } catch (t) {}
        (e = e.split(",")).push("header"), e = [ ...new Set(e) ];
        const r = !window.upcart && (!!t || this.cartDrawerOpen);
        fetch(`${location.pathname.replace("/apps/wishlist", "/")}?sections=${e.join(",")}`, {
          method: "GET"
        }).then((t => t.json())).then((t => {
          Object.entries(t).forEach((t => {
            const [e, a] = t, s = (new DOMParser).parseFromString(a, "text/html");
            i ??= [ `[id^="shopify-section-"][id$="${e}"]` ], i.push("header [data-cart-count]", "form [data-cart-count]", "[data-cart-link]"), 
            i.forEach((t => {
              document.querySelectorAll(t).forEach((e => {
                const i = s.querySelector(t);
                i && (e.innerHTML = r ? i.innerHTML.replace('id="Cart"', 'id="Cart" checked') : i.innerHTML);
              }));
            }));
          }));
        }));
      }
    }
  }));
  var a = r("kmbQD");
  class s extends HTMLElement {
    constructor() {
      super(), this.isCartContext = this.hasAttribute("data-cart-context"), this.save = this.querySelector("[data-save]"), 
      this.close = this.querySelector("[data-close]"), this.remove = this.querySelector("[data-remove]"), 
      this.giftWrapAddBtn = this.querySelector("[data-gift-wrap-add]"), this.giftWrapRadios = Array.from(this.querySelectorAll("[data-gift-wrapping-product]")), 
      this.to = this.querySelector("[data-to]"), this.message = this.querySelector("[data-message]"), 
      this.id = this.querySelector("[data-variant-id]").value, this.giftWrapId = this.querySelector("[data-gift-wrap-id]")?.value, 
      this.giftWrapVariantId = this.querySelector("[data-gift-wrap-variant-id]")?.value, 
      this.key = this.querySelector("[data-key]")?.value, this.quantity = this.querySelector("[data-quantity]")?.value;
    }
    connectedCallback() {
      this.setupEventListeners(), this.setupImagePriceSwap(), this.isCartContext && this.setupGiftWrapUI();
    }
    setupImagePriceSwap() {
      this.giftWrapRadios.forEach((t => {
        t.addEventListener("change", this.handleGiftWrapChange.bind(this));
      }));
    }
    setupGiftWrapUI() {
      this.giftWrapAddBtn && this.giftWrapAddBtn.hasAttribute("disabled") && this.giftWrapAddBtn.removeAttribute("disabled");
    }
    setupEventListeners() {
      this.remove && this.remove.addEventListener("click", this.removeGiftWrap.bind(this)), 
      this.save && this.save.addEventListener("click", (t => this.onClickHandler(t))), 
      this.close && this.close.addEventListener("click", (t => this.closeHandler(t))), 
      this.giftWrapAddBtn && this.isCartContext && this.giftWrapAddBtn.addEventListener("click", this.onGiftWrapToggle.bind(this));
    }
    closeHandler(t) {
      t.preventDefault(), this.querySelector("[data-hide]").click();
    }
    onClickHandler(t) {
      t.preventDefault(), this.isCartContext && (this.product = this.querySelector('[name="gift-wrap-product"]:checked')?.value || null, 
      this.giftWrapId && this.product && this.product !== this.giftWrapId ? this.changeGiftWrap() : this.product ? this.addGiftWrap() : this.removeGiftWrap());
    }
    onGiftWrapToggle() {
      this.giftWrapRadios.some((t => "gift-wrap-product" === t.getAttribute("name"))) ? (this.giftWrapRadios.forEach((t => t.setAttribute("name", "gift-wrap-select"))), 
      this.giftWrapAddBtn.textContent = this.giftWrapAddBtn.dataset.addText, this.isCartContext && this.removeGiftWrap()) : (this.giftWrapRadios.forEach((t => t.setAttribute("name", "gift-wrap-product"))), 
      this.product = this.querySelector('[name="gift-wrap-product"]:checked')?.value || null, 
      this.giftWrapAddBtn.textContent = this.giftWrapAddBtn.dataset.removeText, this.isCartContext && this.product && this.addGiftWrap());
    }
    handleGiftWrapChange(t) {
      const e = t.target, i = e.dataset.productId;
      if (i && (this.querySelectorAll("[data-gift-wrap-image]").forEach((t => {
        t.classList.toggle("opacity-0", t.dataset.giftWrapImage !== i);
      })), this.querySelectorAll("[data-gift-wrap-price]").forEach((t => {
        const e = t.dataset.giftWrapPrice === i;
        t.classList.toggle("hidden", !e);
      }))), this.isCartContext) {
        this.giftWrapRadios.some((t => "gift-wrap-product" === t.getAttribute("name"))) && e.value !== this.giftWrapVariantId && (this.product = e.value, 
        this.changeGiftWrap());
      }
    }
    getGiftMessageProperties() {
      const t = this.to?.value, e = this.message?.value;
      return {
        ...t && {
          to: t
        },
        ...e && {
          message: e
        },
        _gift_wrapped: "true"
      };
    }
    addGiftWrap() {
      const t = this.getGiftMessageProperties();
      a.default.doChange({
        id: this.key,
        quantity: this.quantity,
        properties: t
      }).then((() => {
        this.addGiftWrapProduct();
      }));
    }
    addGiftWrapProduct() {
      a.default.doAdd({
        id: this.product,
        quantity: 1,
        properties: {
          _hidden: "true",
          _related_product_id: this.id
        }
      }, !0);
    }
    removeGiftWrap() {
      a.default.doChange({
        id: this.giftWrapId,
        quantity: 0
      }).then((() => {
        this.updateProductProperties({
          to: "",
          message: "",
          _gift_wrapped: "false"
        });
      }));
    }
    changeGiftWrap() {
      const t = this.getGiftMessageProperties();
      a.default.doChange({
        id: this.giftWrapId,
        quantity: 0
      }).then((() => {
        a.default.doAdd({
          id: this.product,
          quantity: this.quantity,
          properties: {
            _hidden: "true",
            _related_product_id: this.id
          }
        }).then((() => {
          this.updateProductProperties(t);
        }));
      }));
    }
    updateProductProperties(t, e = !0) {
      a.default.doChange({
        id: this.key,
        quantity: this.quantity,
        properties: t
      }, e);
    }
  }
  customElements.get("gift-wrapping") || customElements.define("gift-wrapping", s);
}();